import type { FC } from "react";

interface MaticLogoProps {
  classes?: string;
  /** @deprecated Use CSS color on parent instead - logo now uses currentColor */
  color?: string;
}

/** The wordmark as Figma draws it (Homepage Header 08 10 26, 9320:5073). */
const MaticLogo: FC<MaticLogoProps> = ({ classes }) => {
  return (
    <svg
      width="181"
      height="52"
      fill="currentColor"
      viewBox="0 0 181 52"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5796 22.4178C71.1865 22.4178 70.0577 23.5493 70.0577 24.9456V36.3458C70.0577 37.742 71.1865 38.8735 72.5796 38.8735H84.8453V51.5013H72.5796C64.2287 51.5013 57.459 44.716 57.459 36.3458C57.459 32.5451 57.459 28.3818 57.459 24.5829C57.459 16.2127 64.2287 9.30042 72.5796 9.30042H73.5402C87.9245 9.30042 99.586 21.1159 99.586 35.5334V51.4705H86.9873V35.8961C86.9873 28.4525 80.9666 22.4178 73.5402 22.4178H72.5796Z"
      />
      <path d="M101.73 0V38.2987C101.73 45.8656 107.851 52 115.4 52C122.95 52 129.07 45.8656 129.07 38.2987V24.5666H116.471V38.2987C116.471 38.8917 115.992 39.3722 115.4 39.3722C114.809 39.3722 114.329 38.8917 114.329 38.2987V22.3961H129.077V9.83171H114.329V0H101.73Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.236 51.5014V9.83173H143.835V51.5032H131.236V51.5014Z"
      />
      <path d="M129.791 0C129.802 4.21955 133.216 7.63399 137.427 7.63399C141.639 7.63399 145.053 4.21774 145.064 0H129.791Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.281 36.5452C158.281 37.9233 159.41 39.0403 160.803 39.0403C167.535 39.0403 174.267 39.0403 180.998 39.0403V51.5013H160.803C152.452 51.5013 145.683 44.8048 145.683 36.5452V35.595C145.683 21.3679 157.341 9.8335 171.727 9.8335H181V22.3906H171.727C164.302 22.3906 158.281 28.2494 158.281 35.595V36.5452Z"
      />
      <path d="M21.353 32.2096C21.353 27.0744 17.5412 23.0362 12.5987 22.3761V51.5032H0V20.3688C0 14.1419 4.85385 9.27502 11.9745 9.27502C18.0875 9.27502 22.0314 11.4582 25.6749 13.9552C27.9092 11.6269 29.854 9.3675 34.7748 9.27502C44.4155 9.09369 55.3064 18.1149 55.3064 31.847V51.5013H42.7077V32.2096C42.7077 27.0744 38.8959 23.0362 33.9534 22.3761V51.5032H21.3548V32.2115L21.353 32.2096Z" />
    </svg>
  );
};

export default MaticLogo;
